// export default function lang(state = {}, action = {}) {
//   switch (action.type) {
//     case "CHANGE_LANG":
//       return action.lang;
//
//     default:
//       return "cn";
//   }
// }


import { CHANGE_LANG } from '../types'

const initialState = {
  default: 'en'
}

export default function(state = initialState, action){
  switch(action.type){
    case CHANGE_LANG:
      return {
        ...state,
        ...action.payload
      }

    default:
      return state;

  }
}
